import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { FunctionAliasModel } from 'Pages/pp/matrixRole'

export const matrixRoleApi = {
	updateOne: async (role_id: number, function_ids: number[]) => {
		const res = await axiosDS().patch(`${urls.pp.matrix_role.role}/${role_id}`, {
			data: { function_ids },
		})
		return res.data
	},

	getOne: async (id: number) => {
		const res = await axiosDS().get(`${urls.pp.matrix_role.role}/${id}`)
		return res.data
	},

	getFunctions: async () => {
		const res = await axiosDS().get<FunctionAliasModel[]>(urls.pp.matrix_role.function)
		return res.data
	},
}
